'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonMenu = require('./commonMenu');

var _commonMenu2 = _interopRequireDefault(_commonMenu);

var _secondaryMenuItemBuilder = require('./secondaryMenuItemBuilder');

var _secondaryMenuItemBuilder2 = _interopRequireDefault(_secondaryMenuItemBuilder);

var _secondaryMenuItemActiveNarrow = require('./secondaryMenuItemActiveNarrow');

var _secondaryMenuItemActiveNarrow2 = _interopRequireDefault(_secondaryMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Secondary Menu
 * @augments CommonMenu
 * @constructor
 */
/**
 * @module navigation/secondaryMenu
 * @requires module: navigation/commonMenu
 * @requires module: navigation/secondaryMenuItemBuilder
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function SecondaryMenu() {
    _commonMenu2.default.prototype.constructor.apply(this, arguments);

    this.activeItemNarrow = new _secondaryMenuItemActiveNarrow2.default('#secondaryCurrent');

    this.itemBuilder = new _secondaryMenuItemBuilder2.default();
    this.itemSelector = '.rn-secondaryNav__list__item';

    this.$outerObj = (0, _jquery2.default)('.rn-secondaryNav');
    this.$navPointer = (0, _jquery2.default)('.rn-secondaryNav__pointer');
    this.$select = (0, _jquery2.default)('.rn-secondaryNav__select');
    this.$close = (0, _jquery2.default)('.rn-secondaryNav__close');
    this.$parent = (0, _jquery2.default)('body');
    this.$overlay = (0, _jquery2.default)('<div class="ui-overlay" />');
    this.$overlayFrom = (0, _jquery2.default)('.rn-menuBar');

    this.secondaryPointerPreRender = 'rn-secondaryNav__pointer_preRender';
    this.secondaryActiveClass = 'rn-secondaryNav_active';
    this.openedSecondary = false;
    this.firstClickSecondary = false;

    this.init();
}
SecondaryMenu.prototype = (0, _create2.default)(_commonMenu2.default.prototype);

SecondaryMenu.prototype._bindEvents = function () {
    this._showHiddenActiveElement();
};

/**
 * @returns {Function}
 * @private
 */
SecondaryMenu.prototype._showHiddenActiveElement = function () {
    $(document).on('ready', function () {
        if (!(0, _jquery2.default)('.rn-secondaryNav')[0]) {
            return false;
        }

        var activeItem = (0, _jquery2.default)('.rn-secondaryNav__list__link.ui-link.ui-link_marked')[0];

        if (!activeItem) {
            var targetNode = (0, _jquery2.default)('.rn-secondaryNav')[0];
            var config = { attributes: false, childList: true, subtree: true };

            // Callback function to execute when mutations are observed
            var callback = function callback(mutationList, observer) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(mutationList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var mutation = _step.value;

                        if (mutation.type === 'childList') {
                            var renderedActiveItem = (0, _jquery2.default)('.rn-secondaryNav__list__link.ui-link.ui-link_marked')[0];
                            // There is a bug. Tomorrow is not marked as active
                            if (renderedActiveItem) {
                                renderedActiveItem.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'nearest'
                                });
                                observer.disconnect();
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };

            var observer = new MutationObserver(callback);

            observer.observe(targetNode, config);
        } else {
            activeItem.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
    });
};

/**
 * @inheritdoc
 */
SecondaryMenu.prototype.render = function () {
    _commonMenu2.default.prototype.render.apply(this, arguments);
};

exports.default = SecondaryMenu;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/secondaryMenu.js
// module id = 1784
// module chunks = 1